import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { availabilitiesResource } from '@lib/resources';
import { EntityID } from '@lib/resources/types';

import CardAppointmentDetails from '../CardAppointmentDetails';
import { CardAppointmentDetailsProps } from '../CardAppointmentDetails/CardAppointmentDetails';

export interface CardAvailabilityProps {
  id: EntityID;
  className?: CardAppointmentDetailsProps['className'];
  showDate?: CardAppointmentDetailsProps['showDate'];
}

const CardAvailability: React.FC<CardAvailabilityProps> = ({ id, ...other }) => {
  const dispatch = useDispatch();

  const availability = useSelector(availabilitiesResource.makeSelectEntity(id));

  useEffect(() => {
    dispatch(availabilitiesResource.fetch({ id, meta: { includeLookups: { provider: {}, facility: {} } } }));
  }, [dispatch, id]);

  if (!availability) {
    return <></>;
  }

  return <CardAppointmentDetails data={availability} {...other} />;
};

export default CardAvailability;
